import React from 'react';
import { connect } from 'react-redux';

import PageHeader from '../../modules/PageHeader';
import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import AccountForm from '../../forms/Account';
import Page from '../../pages/Page';

import * as accountActions from '../../../actions/account';
import { selectSessionUserId } from '../../../selectors/users';

class Account extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isShowingAuthenticationMethods: false
        };

        this._setAuthSetupSuccess = this._setAuthSetupSuccess.bind(this);
    }

    componentDidMount() {
        this.props.resetAccount();
        this.props.refreshAccount(this.props.sessionUserId);
        this.props.setAuthSetupSuccess(false);
    }

    _saveAccount(values) {

        return this.props.saveAccount(values)
            .then((savedUser) => {
                if (savedUser.confirmed === false) {
                    this.props.history.push('/login');
                } else {
                    this.props.setAuthSetupSuccess(false);
                }
            });

    }

    _setAuthSetupSuccess() {
        this.props.setAuthSetupSuccess(true);
        this.props.refreshAccount(this.props.sessionUserId);
    }

    _on2FAChange(e) {
        if (e.target.checked) {
            this.setState({ isShowingAuthenticationMethods: true });
        } else {
            this.setState({ isShowingAuthenticationMethods: false });
        }
    }

    _setInitialShowState(state) {
        this.setState({ isShowingAuthenticationMethods: state });
    }

    render() {

        return (
            <Page>
                <PageMeta title="My Account" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <PageHeader>
                        <h1>My Account</h1>

                        <span>Change your account details in one place for all of your RHE Global services.</span>
                    </PageHeader>

                    <PageSection>
                        {(this.props.account && Object.keys(this.props.account).length > 0 && !this.props.isLoadingAccountDetails) &&
                            <AccountForm
                                initialValues={this.props.account}
                                onSubmit={this._saveAccount.bind(this)}
                                enableReinitialize={true}
                                on2FAChange={this._on2FAChange.bind(this)}
                                setInitialShowState={(state) => this._setInitialShowState(state)}
                                isShowingAuthenticationMethods={this.state.isShowingAuthenticationMethods}
                                authSetupSuccessful={this.props.authSetupSuccessful}
                                setAuthSetupSuccess={this._setAuthSetupSuccess.bind(this)}
                            />
                        }
                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = state => {
    return {
        sessionUserId: selectSessionUserId(state),
        account: state.account.account,
        isLoadingAccountDetails: state.account.isLoadingAccountDetails,
        authSetupSuccessful: state.account.authSetupSuccessful
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetAccount() {
            dispatch(accountActions.accountReceived(null));
        },
        refreshAccount(userId) {
            return dispatch(accountActions.refreshAccount(userId));
        },
        saveAccount(values) {
            return dispatch(accountActions.saveAccount(values));
        },
        setAuthSetupSuccess(isSuccessful) {
            return dispatch(accountActions.authSetupSuccess(isSuccessful));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);